import React from "react";
import { Box, Paper, useMediaQuery, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { motion } from "framer-motion";
import LogoImage from "./LogoImage";

const LoginLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100%",
        background: "linear-gradient(135deg, #004e92 0%, #000428 100%)",
        overflow: "hidden",
      }}
    >
      {/* Sidebar Section */}
      {!isMobile && (
        <Box
          sx={{
            width: "40%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            p: 5,
          }}
        >
          <LogoImage color="#fff" />
          <Typography variant="h5" sx={{ mt: 3, fontWeight: 300 }}>
            Plateforme de Maintenance
          </Typography>
          <Typography variant="body1" sx={{ mt: 1, opacity: 0.8 }}>
            Produits et équipements destinés au transport
          </Typography>
        </Box>
      )}

      {/* Form Section */}
      <Paper
        component={motion.div}
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        elevation={6}
        sx={{
          flex: 1,
          borderRadius: "0 0 0 80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 3, md: 6 },
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 420 }}>{children}</Box>
      </Paper>
    </Box>
  );
};

export default LoginLayout;
